module.exports = __webpack_public_path__ + "img/3.80aa3f9a.png";